// extracted by mini-css-extract-plugin
export default {"Body":"Page_Body__0ZSov","Page":"Page_Page__Kh2rX"};